import { render, staticRenderFns } from "./effect.vue?vue&type=template&id=01bb7159&scoped=true"
import script from "./effect.vue?vue&type=script&lang=js"
export * from "./effect.vue?vue&type=script&lang=js"
import style0 from "./effect.vue?vue&type=style&index=0&id=01bb7159&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb7159",
  null
  
)

export default component.exports